type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = 'GTM-WTNVSBK5';

export const pageview = (url: string, event?: string) => {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: event || 'pageview',
      page: url,
    });
  }
};
